<div class="card hs-main-panel" [hidden]="(isVisible$ | async) === false">
    <hs-panel-header name="feature_table" [title]="'PANEL_HEADER.FEATURE_TABLE' | translateHs"></hs-panel-header>
    <div class="card-body">
        <div *ngFor="let layer of layers">
            <hs-layer-features [layer]="layer"></hs-layer-features>
        </div>
    </div>
</div>